export default {
  title: 'OMSAG Tools',
  locales: [
    {
      name: 'de',
      text: 'Deutsch',
    },
    {
      name: 'en',
      text: 'English',
    },
  ],
  defaultLocale: 'de',
  iconfont: 'md',
  // primaryTheme: 'dark',
  // secondaryTheme: 'dark',
  // theme: {
  //   primary: '#34495e',
  //   secondary: '#41b883',
  //   accent: '#82B1FF',
  //   error: '#FF5252',
  //   info: '#2196F3',
  //   success: '#4CAF50',
  //   warning: '#FFC107',
  // },
  primaryTheme: 'light',
  secondaryTheme: 'light',
  theme: {
    primary: '#50AA3C',
    // primary: 'white',
    // secondary: '#DCE6CD',
    secondary: '#50AA3C',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
  },
}
